import { SC_Input } from "../input/SC_Input";
import { RoofType } from "../roof/RoofType";
import { Sol50Integrated } from "./Sol50Integrated";
import { RoofItemType } from './roofItemType';
import { SubFrameIn } from './subFrameIn';

export function getAllInStringIntegrated(): RoofItemType[] {
	var sRes: RoofItemType[] = [];
	// console.log(SC_Input.nModThick)
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sHProfilVar, SubFrameIn.getHProfil()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sAbschSteckVar, SubFrameIn.getAbschSteck()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sSAMTrapez2mVar, SubFrameIn.getSAMTrapez2m()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sSAMTrapez1mVar, SubFrameIn.getSAMTrapez1m()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sProfueller18160Var, SubFrameIn.getProfueller18160()));
	switch (SC_Input.iRoofType) {
		case RoofType.SLATED:
		case RoofType.PLAIN_TILED:
			sRes.push(new RoofItemType(NaN, Sol50Integrated.sDichtband5_6Var, SubFrameIn.getDichtband5_6()));
			break;
		default:
			sRes.push(new RoofItemType(NaN, Sol50Integrated.sKehlDSVar, SubFrameIn.getKehlDS()));
	}
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sEindeckblechVar, SubFrameIn.getEindeckblech()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sAbschBlechVar, SubFrameIn.getAbschBlech()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sTraufLuftProfVar, SubFrameIn.getTraufLuftProf()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sHAbschKapESVar, SubFrameIn.getHAbschKapES()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sEdelBohrVar, SubFrameIn.getEdelBohr()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sVDichtSVar, SubFrameIn.getVDichtS()));
	sRes = sRes.concat(SubFrameIn.getKabFanNetAndBohrSchrString());
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sBitBandAlu10mVar, SubFrameIn.getBitBandAlu10m()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sErdbausatzVar, SubFrameIn.getErdbausatz()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sTopAbschlussblechVar, SubFrameIn.getTopAbschlussblech()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sLuKamVar, SubFrameIn.getLuKam()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sAnKleBanVar, SubFrameIn.getAnKleBan()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sDichtbandVar, SubFrameIn.getDichtband()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sEckAnsVar, SubFrameIn.getEckAns()));
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sHafKleHalVar, SubFrameIn.getHafKleHal()));
	if (Sol50Integrated.sDistAdapVar != "") {
		sRes.push(new RoofItemType(NaN, Sol50Integrated.sDistAdapVar, SubFrameIn.getDistAdap()));
	}
	// console.log(sRes)
	sRes.push(new RoofItemType(NaN, Sol50Integrated.sSOLGuardVar, SubFrameIn.getSOLGuard()));
	return sRes;
}
